export default __webpack_public_path__ + "static/media/juice-fruit-product-l-tablet@3x.6044ca49.png";